import React from 'react';
import { Button, useTheme, useMediaQuery } from '@mui/material';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

function OpenCalculation({ onOpenCalculation }) {
  const handleOpenFile = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = (event) => handleFileSelection(event.target.files[0]);
    input.click();
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  

  const handleFileSelection = (file) => {
    if (!file) {
      return;
    }

    
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const jsonData = JSON.parse(event.target.result);
        onOpenCalculation(jsonData);
      } catch (error) {
        console.error('Error parsing JSON data:', error);
        // Handle invalid JSON data
      }
    };

    

    reader.readAsText(file);
  };
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleOpenFile}
      // Only show the icon in the `startIcon` prop on larger screens
      startIcon={!isMobile ? <FolderOpenIcon /> : null}
      sx={{
        borderRadius: "12px",
        fontFamily: "'Hubballi', sans-serif",
        fontSize: "1.1rem",
        textTransform: "none",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        // When on mobile, adjust padding and minWidth for an icon-only button
        ...(isMobile && {
          minWidth: 'auto', // Remove the default min-width
          padding: '0.6rem', // Make the padding equal for a more circular look
        }),
        // When on desktop, use the original padding
        ...(!isMobile && {
          padding: "0.3rem 1.2rem",
        }),
      }}
    >
      {/* Conditionally render the content of the button */}
      {isMobile ? <FolderOpenIcon /> : "Open Calculation"}
    </Button>
  );
};

export default OpenCalculation;